import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { MaintanceFacade } from '@cpd-app/state/maintance';
import { AppState } from '@cpd-app/state';
import { selectProfileWorkTypeSet } from '@cpd-app/state/user-profile/user-profile.selectors';

export const siteBlockGuard: CanActivateFn = () => {
  return inject(MaintanceFacade).siteBlocked$.pipe(map((blocked) => !blocked));
};

export const siteReroutingGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);
  const selectProfileWorkTypeSet$ = store.select(selectProfileWorkTypeSet);

  return selectProfileWorkTypeSet$.pipe(
    map((isSet) =>
      isSet ? true : router.createUrlTree(['/profile-work-type'])
    )
  );
};
